import { Dialog, Button, CircularProgress, CardMedia } from '@material-ui/core';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import Completed from '../../../../../src/images/completed.png';
import { SubmitButton } from '../../../../lib/Button';
import { searchInactiveFolios } from '../../../../redux-store/actions/link';
import { InactiveFolioPaths } from '../types';
import { ProfileEvent, useProfileInfo, validateProfile } from './profile-context';
import {
    ProfileReducerState,
    SearchInactiveFoliosRequestType,
    SearchInactiveFoliosResponseType,
} from './types';
import { ObjectiveDetail, SubjectiveDetail } from './utils';

export const Submit = ({
    reqId,
    pan,
    registerDetails,
}: {
    reqId: string;
    pan: string;
    registerDetails: { by: string; details: string };
}) => {
    const { state: profileState, dispatch: profileDispatch } = useProfileInfo();

    const reduxDispatch = useDispatch();
    const history = useHistory();

    const [show, setShow] = useState(false);
    const [loading, setLoading] = useState(false);

    const [success, setSuccess] = useState(false);

    const handleProceed = async () => {
        try {
            profileDispatch({
                action: ProfileEvent.SetSubmitted,
                payload: true,
            });
            const { errors, valid } = validateProfile(profileState);
            if (!valid) return;
            const checkSearchType = (searchType: string) => {
                const { subjective, objective } = profileState;
                const subjectiveTypes = subjective.map((o) => o.type);
                if (objective.type === searchType) return objective.value;
                else if (subjectiveTypes.includes(searchType as SubjectiveDetail))
                    return subjective.find((o) => o.type === (searchType as SubjectiveDetail))!
                        .value;
                return '';
            };
            const searchInactiveFoliosReqBody: SearchInactiveFoliosRequestType = {
                pan,
                pekrn: '',
                email: registerDetails.by === 'EMAIL' ? registerDetails.details : '',
                mobile: registerDetails.by === 'MOBILE' ? registerDetails.details : '',
                reqId,
                data: [
                    {
                        searchPan: checkSearchType(ObjectiveDetail.PAN),
                        searchPekrn: checkSearchType(ObjectiveDetail.Pekrn),
                        searchEmail: checkSearchType(ObjectiveDetail.Email),
                        onlySubjective:
                            profileState.objective.type === ObjectiveDetail.None ? 'Y' : 'N',
                        searchMobile: checkSearchType(ObjectiveDetail.Mobile),
                        invName: profileState.investorName,
                        nomineeName: checkSearchType(SubjectiveDetail.NomineeName),
                        searchFor: profileState.investType.toUpperCase(),
                        city: checkSearchType(SubjectiveDetail.City),
                        dob: checkSearchType(ObjectiveDetail.DOB),
                        pincode: checkSearchType(SubjectiveDetail.PinCode),
                        accNo: checkSearchType(ObjectiveDetail.BankAccountNumber),
                        address: checkSearchType(SubjectiveDetail.Address),
                        folio: profileState.folio,
                        amc: profileState.amcCode,
                        cin: '',
                    },
                ],
            };
            setLoading(true);
            const { body: searchInactiveFoliosResBody } = await searchInactiveFolios(
                searchInactiveFoliosReqBody,
            )(reduxDispatch);
            history.push(`/links${InactiveFolioPaths.TRACK_INTERMEDIATE}`, {
                pan,
                reqId: searchInactiveFoliosResBody.reqId,
                registerDetails,
            });
        } catch (err: any) {
            alert(err.message);
        } finally {
            setLoading(false);
        }
    };
    return (
        <>
            <SubmitButton
                type="submit"
                onClick={handleProceed}
                disabled={profileState.submitted && !profileState.valid}
                label="Proceed"
                style={{ width: '30%', marginLeft: 'auto', marginRight: 'auto', marginTop: '12px'}}
            />
            <Dialog maxWidth={'sm'} open={show} aria-labelledby="note-modals">
                <div className="note-modals">
                    <h3>Inactive Folios</h3>
                    <p>No Inactive folios were found for the corresponding details</p>
                    <div className="note-modals-btns">
                        <Button
                            className="customBtn"
                            style={{ width: '100%' }}
                            onClick={() => {
                                setShow(false);
                            }}
                        >
                            Retry with different details
                        </Button>
                    </div>
                </div>
            </Dialog>
            <Dialog maxWidth={'sm'} open={loading} aria-labelledby="enable-fingerprint-modal">
                <div className="enable-fingerprint-modal">
                    <CircularProgress />
                    <p style={{ marginTop: '12px' }}>{'Searching Inactive Folios...'}</p>
                </div>
            </Dialog>
        </>
    );
};
